<template lang="pug">
.search-study
  pulldown-search.search-study__select(v-model='selectedYear', :selectOptions='yearSelectOptions')
    slot(name='yearLabel')
  pulldown-search.search-study__select(v-model='selectedMonth', :selectOptions='monthSelectOptions')
    slot(name='monthLabel')
  pulldown-search.search-study__select(v-model='selectedGrade', :selectOptions='gradeSelectOptions')
    slot(name='gradeLabel')
  button-search.search-study__button(:data-disabled='disabled', @click='doSearch')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import PulldownSearch from '@/components/molecules/student/PulldownSearch.vue'
import ButtonSearch from '@/components/molecules/student/ButtonSearch.vue'
import { InputItem } from '@/models/inputItem'

/**
 * 学習検索
 */
@Component({
  components: {
    PulldownSearch,
    ButtonSearch,
  },
})
export default class SearchStudy extends Vue {
  // 検索ボタン押下時イベント
  @Prop()
  searchEvent!: Function

  // 学年選択オプション
  @Prop()
  gradeSelectOptions!: InputItem[]

  // 実施年度選択オプション
  @Prop()
  yearSelectOptions!: InputItem[]

  // 実施月選択オプション
  @Prop()
  monthSelectOptions!: InputItem[]

  // 学年選択値
  @Prop()
  gradeValue!: string

  // 実施年度選択値
  @Prop()
  yearValue!: string

  // 実施月選択値
  @Prop()
  monthValue!: string

  // 学年変更時イベント
  @Prop()
  gradeChangeEvent!: Function

  // 実施年度変更時イベント
  @Prop()
  yearChangeEvent!: Function

  // 実施月変更時イベント
  @Prop()
  monthChangeEvent!: Function

  /**
   * プルダウンのゲッター・セッター
   */
  // 学年ゲッター・セッター
  get selectedGrade(): string {
    return this.gradeValue
  }
  set selectedGrade(value: string) {
    this.gradeChangeEvent(value)
  }
  // 実施年度
  get selectedYear(): string {
    return this.yearValue
  }
  set selectedYear(value: string) {
    this.yearChangeEvent(value)
  }

  // 実施月
  get selectedMonth(): string {
    return this.monthValue
  }
  set selectedMonth(value: string) {
    this.monthChangeEvent(value)
  }

  // 実施年度、実施月、学年は必須で未入力時は検索不可
  private get disabled(): boolean {
    return this.yearValue === '' || this.monthValue === '' || this.gradeValue === ''
  }

  private doSearch() {
    if (this.disabled) return

    this.searchEvent()
  }
}
</script>

<style lang="stylus" scoped>
.search-study
  width 100%
  display flex
  flex-wrap wrap
  align-items flex-end
  justify-content space-between
</style>
